






























import { Component, Mixins, Watch } from 'vue-property-decorator';
import LocalizationMixin from '@/common/views/mixins/LocalizationMixin';
import ContentHeader from '@/common/views/components/ContentHeader.vue';
import ContentFooter from '@/common/views/components/ContentFooter.vue';

import ContactForm from '@/contactus/views/ContactForm';
import Confirmation from '@/contactus/views/Confirmation';
import Finish from '@/contactus/views/Finish';
import { create } from 'domain';

type PageName = 'ContactForm' | 'Confirmation' | 'Finish';
type OptInState = 'yes' | 'no' | null;

const OPT_IN_KEY = 'ga_cookie_opt_in';

const isOptInState = (value: any): value is OptInState => value === 'yes' || value === 'no' || value === null;

const trackingUrl: Record<PageName, string> = {
  'ContactForm': '/contactus',
  'Confirmation': '/contactus/confirm',
  'Finish': '/contactus/finish',
}
const createTrackingPage = (name: PageName, lang: string): string => `${trackingUrl[name]}${lang === 'ja' ? '' : `?locale=${lang}`}`;

@Component({ components: { ContentHeader, ContentFooter, ContactForm, Confirmation, Finish } })
export default class App extends Mixins(LocalizationMixin) {
  private titleKey = 'contact.title';
  private currentPage: PageName = 'ContactForm';
  private gaCookieOptIn: OptInState = null;
  private enableGa = false;
  private prevLocale = '';

  beforeMount() {
    const gaCookieOptIn = localStorage.getItem(OPT_IN_KEY);
    this.gaCookieOptIn = isOptInState(gaCookieOptIn) ? gaCookieOptIn : null;
  }

  mounted() {
    this.prevLocale = this.$i18n.locale;
    this.changeGaOptIn();
  }

  acceptGa() {
    this.gaCookieOptIn = 'yes';
  }

  rejectGa() {
    this.gaCookieOptIn = 'no';
  }

  get needsGaBanner() {
    return this.$i18n.locale === 'en' && !this.gaCookieOptIn;
  }

  changePage(page: PageName) {
    this.currentPage = page;
    window.scrollTo(0, 0);
    this.changeGaOptIn(true);
  }

  @Watch('gaCookieOptIn')
  watchGaCookieOptIn(value: OptInState) {
    if (!!value) {
      localStorage.setItem(OPT_IN_KEY, value);
    }
    this.changeGaOptIn();
  }

  @Watch('locale')
  watchLocale() {
    this.changeGaOptIn(this.prevLocale !== this.$i18n.locale);
    this.prevLocale = this.$i18n.locale;
  }

  changeGaOptIn(force = false) {
    let newEnableGa = false;
    if (this.$i18n.locale !== 'en') {
      newEnableGa = true;
    } else if (this.$i18n.locale === 'en' && this.gaCookieOptIn === 'yes') {
      newEnableGa = true;
    }

    if (force || (this.enableGa !== newEnableGa)) {
      if (newEnableGa) {
        this.$ga.enable();
        this.trackGa();
      } else {
        this.$ga.disable();
      }
    }

    this.enableGa = newEnableGa;
  }

  trackGa() {
    const page = createTrackingPage(this.currentPage, this.$i18n.locale);
    console.log('trackGa', page);
    this.$ga.page(page);
  }
}
